import '@babel/polyfill';
import 'fontsource-roboto';
import '@/styles/material-ui.scss';
import '@/index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import App from '@/App.component';

import '@/styles/form.scss';

ReactDOM.render(<App />, document.getElementById('root'));
